import { render, staticRenderFns } from "./Deny.vue?vue&type=template&id=79378462&scoped=true&"
import script from "./Deny.vue?vue&type=script&lang=js&"
export * from "./Deny.vue?vue&type=script&lang=js&"
import style0 from "./Deny.vue?vue&type=style&index=0&id=79378462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../boss_taobao/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79378462",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../boss_taobao/admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VBtn,VContainer,VLayout})
